export default __webpack_public_path__ + "static/nusrisk-8fa94a3f960dc4f960b3299aaddcbe81.png";